import { Component, Input, OnInit } from '@angular/core';
import { ProcesoFirma } from '../../interfaces/datos-firma-interface';

@Component({
  selector: 'app-documento-vista',
  templateUrl: './documento-vista.component.html',
  styleUrls: ['./documento-vista.component.css']
})
export class DocumentoVistaComponent implements OnInit {

  @Input() procesoFirma: ProcesoFirma;
  datosProceso: ProcesoFirma;
  pdfSource: string;
  pageNumber: number = 1;
  
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: any): void {
    if(changes['procesoFirma'] && this.procesoFirma) {

      if (this.procesoFirma.estadoProcesoFirma.idEstadoProceso === 1) {
        this.pdfSource = this.procesoFirma.documentoProcesoFirma.urlDocumentoOriginal;
      } else {
        this.pdfSource = this.procesoFirma.documentoProcesoFirma.urlDocumentoFirmado;
      }      
      this.datosProceso = this.procesoFirma;
    }    
  }
}
